import * as React from 'react'

interface FloatingBannerContextType {
  onClose: () => void
}

export const FloatingBannerContext = React.createContext<
  FloatingBannerContextType | undefined
>(undefined)

export const useFloatingBanner = () => {
  const context = React.useContext(FloatingBannerContext)
  if (context === undefined) {
    throw new Error(
      'useFloatingBanner must be used within a FloatingBannerProvider'
    )
  }
  return context
}
